/* ZSportsTech — section-book.js
   Scoped to #sc-brbook (Bat Repair · 03 book).
   Chip toggles · photo drag-drop/upload · pay vs estimate-only paths · basic validation.
   Maps to → assets/section-book.js in Shopify theme.
   ─────────────────────────────────────────────────── */
(function () {
  'use strict';

  var root = document.getElementById('sc-brbook');
  if (!root) return;

  /* ── 1. Chip groups (single-select per group) ── */
  root.querySelectorAll('[data-brbook-chips]').forEach(function (group) {
    group.querySelectorAll('.sc-brbook__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        group.querySelectorAll('.sc-brbook__chip').forEach(function (c) {
          c.classList.remove('is-active');
          c.setAttribute('aria-pressed', 'false');
        });
        chip.classList.add('is-active');
        chip.setAttribute('aria-pressed', 'true');
      });
    });
  });

  /* ── 2. Photo upload (drag-drop + tap) ── */
  var drop   = root.querySelector('[data-brbook-drop]');
  var input  = root.querySelector('[data-brbook-file]');
  var thumbs = root.querySelector('[data-brbook-thumbs]');
  var store  = [];

  function renderThumbs() {
    if (!thumbs) return;
    thumbs.innerHTML = '';
    store.forEach(function (item, i) {
      var t = document.createElement('div');
      t.className = 'sc-brbook__thumb';
      t.innerHTML = '<img alt="' + item.name + '"><button type="button" class="sc-brbook__thumb-x" aria-label="Remove photo">×</button>';
      t.querySelector('img').src = item.url;
      t.querySelector('.sc-brbook__thumb-x').addEventListener('click', function () {
        URL.revokeObjectURL(item.url);
        store.splice(i, 1);
        renderThumbs();
      });
      thumbs.appendChild(t);
    });
    thumbs.style.display = store.length ? 'grid' : 'none';
  }

  function addFiles(files) {
    Array.prototype.slice.call(files).forEach(function (f) {
      if (!/^image\//.test(f.type)) return;
      store.push({ name: f.name, url: URL.createObjectURL(f) });
    });
    renderThumbs();
  }

  if (drop && input) {
    drop.addEventListener('click', function () { input.click(); });
    drop.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
    });
    input.addEventListener('change', function () { addFiles(input.files); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-drag'); });
    });
    ['dragleave', 'drop'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-drag'); });
    });
    drop.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });
  }

  /* ── 3. Carry order summary from §02 ── */
  function fmt(n) { return '₹' + n.toLocaleString('en-IN'); }
  try {
    var raw = sessionStorage.getItem('zbat:quote');
    if (raw) {
      var sel = JSON.parse(raw);
      var total = sel.reduce(function (s, it) { return s + it.price * (it.qty || 1); }, 0);
      var count = sel.length;
      if (count > 0) {
        root.querySelectorAll('[data-brbook-count]').forEach(function (el) {
          el.textContent = count + (count === 1 ? ' service' : ' services');
        });
        root.querySelectorAll('[data-brbook-total]').forEach(function (el) { el.textContent = fmt(total); });
      }
    }
  } catch (e) {}

  /* ── 4. Validation + path handlers ── */
  function validate() {
    var ok = true;
    root.querySelectorAll('[data-brbook-required]').forEach(function (f) {
      var bad = !f.value.trim();
      f.classList.toggle('is-invalid', bad);
      if (bad) ok = false;
    });
    return ok;
  }
  root.querySelectorAll('[data-brbook-required]').forEach(function (f) {
    f.addEventListener('input', function () { f.classList.remove('is-invalid'); });
  });

  var pay = root.querySelector('[data-brbook-pay]');
  if (pay) pay.addEventListener('click', function () {
    if (!validate()) return;
    /* DEV: package order + selection → Shopify checkout (Razorpay) + ShipRocket pickup */
    root.setAttribute('data-brbook-path', 'pay');
  });

  /* Estimate path: the customer pays the two-way courier now (a real product,
     zero-rate shipping profile) and the form details travel on the Shopify
     order as line-item properties. Photos stay on WhatsApp; only the count
     is recorded. */
  var COURIER_VARIANT = 45454040203373; /* Bat Inspection · Two-way Courier · BR-COURIER */
  function formProperties() {
    var props = { 'Request': 'Estimate first · inspection + two-way courier' };
    var labels = ['Bat type', 'Current weight', 'Mode'];
    var groups = root.querySelectorAll('[data-brbook-chips]');
    Array.prototype.forEach.call(groups, function (g, i) {
      var on = g.querySelector('.is-active');
      if (on) props[labels[i] || ('Choice ' + (i + 1))] = on.textContent.trim();
    });
    root.querySelectorAll('.sc-brbook__input').forEach(function (f) {
      var key = (f.getAttribute('placeholder') || 'Field').replace(' (optional)', '');
      if (f.value.trim()) props[key] = f.value.trim();
    });
    if (store.length) props['Photos'] = store.length + ' photo(s) taken, customer sends them on WhatsApp';
    return props;
  }
  root.querySelectorAll('[data-brbook-estimate]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!validate()) return;
      var label = btn.textContent;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: COURIER_VARIANT, quantity: 1, properties: formProperties() }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      }).catch(function () {
        btn.removeAttribute('aria-busy');
        btn.textContent = label;
        /* Show the drawer, never navigate to the cart page — the drawer is the cart. */
        if (window.SCCart) { window.SCCart.refresh(); window.SCCart.open(); }
      });
    });
  });
}());
